import './about.css'
import Fade from 'react-reveal/Fade';

export default function About() {
    return(
        <div id='body' className='m-auto'>
            <div id='page-satu'>
                <div id='edukasi'>
                    <Fade bottom>
                    <h1>Edukasi</h1>
                    </Fade>
                    
                    <Fade bottom>
                    <div className='mt-5 d-flex justify-content-between'>
                        <h2 className='w-50'>
                            <strong>SMAK 2 Penabur Jakarta</strong><br></br>
                            Jul 2017 - Mei 2020
                        </h2>
                        <h2 className='w-50'>
                            <ul>
                                <li>Lulusan SMA tahun 2020</li>
                            </ul>
                        </h2>
                    </div>
                    </Fade>
                </div>

                <div id='kesukaan'>
                    <Fade bottom>
                    <h1 >Kesukaan</h1>
                    </Fade>

                    <Fade bottom>
                    <div className='mt-5 d-flex justify-content-between'>
                        <h2 className='w-50'>
                            <ul >
                                <li>Ingin tahu bagaimana seni dibuat</li>
                                <li>Videography</li>
                                <li>Photography</li>
                            </ul>
                        </h2>
                        <h2 className='w-50'>
                            <ul>
                                <li>Menonton film</li>
                                <li>Gaya busana</li>
                                <li>Musik</li>
                            </ul>
                        </h2>
                    </div>
                    </Fade>
                </div>
            </div>

            <div id='page-dua'>
                <Fade left>
                <div id='title' className='d-flex align-item-center'>
                    <h1>Pengalaman Kerja</h1>
                    <h2> | <b>Film & Non-film</b></h2>
                </div>
                </Fade>

                <Fade bottom>
                <div id='scroll'>
                    <div id='desc' className='mb-5 d-flex'>
                        <div className='w-50'>
                            <h2><b>REXAR 2019</b></h2>
                            <h2><i>Kepala Divisi Forografi</i></h2>
                            <h2>Jul 2019 - Okt 2019</h2>
                        </div>
                        <div className='w-50 pe-2'>
                            <h2>
                                <ul>
                                    <li>Membuat after movie REXAR 2019</li>
                                    <li>Mengkoordinasikan pengambilan foto atau video</li>
                                    <li>Mengambil momen-momen REXAR 2019</li>
                                </ul>
                            </h2>
                        </div>
                    </div>

                    <div id='desc' className='mb-5 d-flex'>
                        <div className='w-50'>
                            <h2><b>On The Dot Production</b></h2>
                            <h2><i>Sutradara Film "Di Balik Jiwa Yang Kuat"</i></h2>
                            <h2>Jan 2021 - Mei 2021</h2>
                        </div>
                        <div className='w-50 pe-2'>
                            <h2>
                                <ul>
                                    <li>Mengarahkan aktor agar sesuai dengan visi dan misi</li>
                                    <li>Mengembangkan konsep film</li>
                                    <li>Memimpin tim di lokasi syuting</li>
                                </ul>
                            </h2>
                        </div>
                    </div>

                    <div id='desc' className='mb-5 d-flex'>
                        <div className='w-50'>
                            <h2><b>UMN Radio</b></h2>
                            <h2><i>Digital Creative</i></h2>
                            <h2>Jan 2021 - Des 2021</h2>
                        </div>
                        <div className='w-50 pe-2'>
                            <h2>
                                <ul>
                                    <li>Membuat tugas desain kreatif dari divisi lain</li>
                                    <li>Membuat desain dan konten pemrograman</li>
                                    <li>Mengambil foto dan video untuk keperluan promosi</li>
                                </ul>
                            </h2>
                        </div>
                    </div>

                    <div id='desc' className='mb-5 d-flex'>
                        <div className='w-50'>
                            <h2><b>Swakarya Production</b></h2>
                            <h2><i>Art Director "What Now"</i></h2>
                            <h2>Aug 2021 - Des 2021</h2>
                        </div>
                        <div className='w-50 pe-2'>
                            <h2>
                                <ul>
                                    <li>Mengembangkan tampilan atau gaya keseluruhan set</li>
                                    <li>Mencari lokasi set yang sesuai dengan visual sutradara</li>
                                    <li>Berkoordinasi dengan departemen kreatif</li>
                                </ul>
                            </h2>
                        </div>
                    </div>

                    <div id='desc' className='mb-5 d-flex'>
                        <div className='w-50'>
                            <h2><b>Nuvo Films</b></h2>
                            <h2><i>Art Crew "Scared to be Lonely" </i></h2>
                            <h2>Des 2021</h2>
                        </div>
                        <div className='w-50 pe-2'>
                            <h2>
                                <ul>
                                    <li>Membantu menyusun properti</li>
                                    <li>Membantu Art Director mewujudkan visualnya</li>
                                    <li>Membantu dalam pembuatan set</li>
                                </ul>
                            </h2>
                        </div>
                    </div>

                    <div id='desc' className='mb-5 d-flex'>
                        <div className='w-50'>
                            <h2><b>Film UMN</b></h2>
                            <h2><i>Art Crew "Cahaya Cinta Perlahan Menyilaukan"</i></h2>
                            <h2>Jul 2022 - Aug 2022</h2>
                        </div>
                        <div className='w-50 pe-2'>
                            <h2>
                                <ul>
                                    <li>Membuat properti untuk keperluan produksi</li>
                                    <li>Membantu Art Director mewujudkan visualnya</li>
                                    <li>Membantu dalam pembuatan set</li>
                                </ul>
                            </h2>
                        </div>
                    </div>

                    <div id='desc' className='mb-5 d-flex'>
                        <div className='w-50'>
                            <h2><b>Helies Pictures</b></h2>
                            <h2><i>Art Director "Surro" and "Ephemera" </i></h2>
                            <h2>Jan 2022 - Saat ini</h2>
                        </div>
                        <div className='w-50 pe-2'>
                            <h2>
                                <ul>
                                    <li>Mengarahkan tata letak properti untuk kepentingan set</li>
                                    <li>Mengembangkan gaya artistik</li>
                                    <li>Berdiskusi dengan sutradara cara terbaik untuk merepresentasikan konsep secara visual</li>
                                </ul>
                            </h2>
                        </div>
                    </div>

                    <div id='desc' className='d-flex'>
                        <div className='w-50'>
                            <h2><b>Acierto Visuals</b></h2>
                            <h2><i>Art Crew "Tehman"</i></h2>
                            <h2>Okt 2022</h2>
                        </div>
                        <div className='w-50 pe-2'>
                            <h2>
                                <ul>
                                    <li>Membantu menyusun set</li>
                                    <li>Berdiskusi dengan Art Director dalam penyusunan teknis</li>
                                    <li>Membuat properti kebutuhan produksi</li>
                                </ul>
                            </h2>
                        </div>
                    </div>
                </div>
                </Fade>
            </div>

            <div id='page-tiga'>
                <div id='skills'>
                    <Fade bottom>
                    <h1 className='mb-5'>Skills</h1>
                    </Fade>
                            <Fade bottom>
                            <h2  className='mb-3'><b>Hard Skills</b></h2>
                            <div className='d-flex'>
                                <h2 className='w-50'>
                                    <ul>
                                        <li>Sketchup</li>
                                        <li>Adobe Photoshop</li>
                                        <li>Adobe Premiere Pro</li>
                                        <li>Adobe After Effects</li>
                                    </ul>
                                </h2>
                                <h2 className='w-50'>
                                    <ul>
                                        <li>Microsoft Office</li>
                                        <li>Content Creator</li>
                                        <li>DJI Drone Pilot</li>
                                    </ul>
                                </h2>
                            </div> 

                            <h2  className='mb-3'><b>Soft Skills</b></h2>
                            <div className='d-flex'>
                                <h2 className='w-50'>
                                    <ul>
                                        <li>Komunikasi</li>
                                        <li>Kepemimpinan</li>
                                        <li>Manajemen waktu</li>
                                        <li>Mampu beradaptasi</li>
                                    </ul>
                                </h2>
                                <h2 className='w-50'>
                                    <ul>
                                        <li>Kreativitas</li>
                                        <li>Fokus terhadap deadline</li>
                                        <li>Berpikir kritis</li>
                                    </ul>
                                </h2>
                            </div> 
                            </Fade>
                </div>
            </div>
            
        </div>

    )
}